import { render, staticRenderFns } from "./appPreview.vue?vue&type=template&id=8fc00522&scoped=true"
import script from "./appPreview.vue?vue&type=script&lang=js"
export * from "./appPreview.vue?vue&type=script&lang=js"
import style0 from "./appPreview.vue?vue&type=style&index=0&id=8fc00522&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fc00522",
  null
  
)

export default component.exports